import React from 'react';
import { UserCircle } from 'lucide-react';

const AvatarScreen = () => {
  return (
    <div className="min-h-screen bg-white pb-24 flex flex-col">
      {/* Header */}
      <div className="px-6 pt-10 pb-4">
        <p className="text-xs uppercase tracking-[0.2em] text-black/55 mb-2 font-bold">VIRTUAL TRY-ON</p>
        <h1 className="text-2xl font-bold text-black uppercase tracking-wide">
          Avatar
        </h1>
        <p className="text-black/55 text-sm font-normal mt-1">
          Virtual fitting coming soon
        </p>
      </div>

      {/* Coming Soon State */}
      <div className="flex-1 flex flex-col items-center justify-center px-6">
        <div className="w-20 h-20 bg-black/5 rounded-3xl flex items-center justify-center mb-5">
          <UserCircle size={32} strokeWidth={1.5} className="text-black/55" />
        </div>
        <h2 className="text-xl font-bold text-black text-center mb-2 uppercase">
          Coming Soon
        </h2>
        <p className="text-black/55 text-center text-sm font-normal max-w-[280px] leading-relaxed">
          Virtual try-on and avatar personalization will be available in the next update.
        </p>
      </div>
    </div>
  );
};

export default AvatarScreen;